import { IoMdClose } from "react-icons/io";
import classes from "./OverlayModal.module.css";

const OverlayModal = ({ onClose, title, children }) => {
  return (
    <div
      className={`${classes.overlay} d-flex justify-content-center align-items-center`}
    >
      <div className={classes.popupCard}>
        {/* Fixed header */}
        <div
          className={`d-flex justify-content-between ${classes.closeContainer}`}
        >
          <h4>{title}</h4>
          <IoMdClose size={25} onClick={onClose} role="button" />
        </div>

        {/* Scrollable content */}
        <div className={classes.scrollContent}>{children}</div>
      </div>
    </div>
  );
};

export default OverlayModal;
